var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg08(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39 36.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "7.67 32.5 4.67 32.5 4.67 0.5 30.66 0.5 30.66 8.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "33.66 36.5 7.67 36.5 7.67 4.5 26.21 4.5 30.05 8.23 33.66 12 33.66 36.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12.92,
    y1: 11,
    x2: 19.92,
    y2: 11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12.92,
    y1: 15.75,
    x2: 28.42,
    y2: 15.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12.92,
    y1: 20.5,
    x2: 28.42,
    y2: 20.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12.92,
    y1: 25.25,
    x2: 28.42,
    y2: 25.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12.92,
    y1: 30,
    x2: 28.42,
    y2: 30
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "33.66 12 33.66 36.5 7.67 36.5 7.67 4.5 26.21 4.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 25.67,
    y1: 12,
    x2: 33.67,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 25.67,
    y1: 4.5,
    x2: 25.67,
    y2: 12
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg08);
export default __webpack_public_path__ + "static/media/08.f6ef663c2d247d8d93f330099b4bede4.svg";
export { ForwardRef as ReactComponent };